import { IconButton, Modal } from '@citiguide/ui-components';
import { useMenuStore } from '../../store/menuStore';
import LanguageSelector from './LanguageSelector';
import CategoryMenu from './CategoryMenu';
import './Menu.css';

const MenuIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

export default function MainMenu() {
  const { isMainMenuOpen, toggleMainMenu, closeAllMenus } = useMenuStore();

  return (
    <>
      <IconButton
        icon={<MenuIcon />}
        label="Open menu"
        variant="floating"
        size="md"
        round
        className="main-menu__toggle"
        onClick={toggleMainMenu}
      />
      <Modal open={isMainMenuOpen} title="Menu" onClose={closeAllMenus} size="sm">
        <div className="main-menu__content">
          <div className="main-menu__section">
            <h3 className="main-menu__section-title">Language</h3>
            <LanguageSelector />
          </div>
          <div className="main-menu__section">
            <CategoryMenu inline />
          </div>
        </div>
      </Modal>
    </>
  );
}
